export const dtaBoostrap = {
    screenWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    },
    screenHeight() {
        return window.innerHeight|| document.documentElement.clientHeight || document.body.clientHeight;
    },
    isColumnXs() {
        return dtaBoostrap.screenWidth() < 576;
    },
    isColumnSm() {
        return dtaBoostrap.screenWidth() >= 576 && dtaBoostrap.screenWidth() < 768;
    },
    isColumnMd() {
        return dtaBoostrap.screenWidth() >= 768 && dtaBoostrap.screenWidth() < 992;
    },
    isColumnLg() {
        return dtaBoostrap.screenWidth() >= 992 && dtaBoostrap.screenWidth() < 1200;
    },
    isColumnXl() {
        return dtaBoostrap.screenWidth() >= 1200 && dtaBoostrap.screenWidth() < 1400;
    },
    isColumnXXL()   {
        return dtaBoostrap.screenWidth() >= 1400;
    },
    isColumnXlOrUp() {
        return dtaBoostrap.screenWidth() >= 1200;
    }
}
